//Reset data
export const RESET = "USER_DEL_RESET"



//Loading
export const SET_TOGGLE_LOADING = "USER_DEL_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "USER_DEL_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "USER_DEL_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "USER_DEL_SET_MESSAGE"
export const SET_IS_SUCCESS = "USER_DEL_SET_IS_SUCCESS"
export const SET_IS_ERROR = "USER_DEL_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "USER_DEL_SET_TOGGLE_MESSAGE"
export const SET_IS_DELETED = "USER_DEL_SET_IS_DELETE"
export const SET_SHOW_MESSAGE = "USER_DEL_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "USER_DEL_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "USER_DEL_SET_ITEMS"
export const SET_CURRENT_ITEM = "USER_DEL_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "USER_DEL_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "USER_DEL_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "USER_DEL_SET_HIDE_MODAL"
